import { Field } from 'react-final-form';

import { Select as SelectTHC } from '@motorway/mw-highway-code/pre-alpha';

import { PLACEHOLDER_TEXT } from '../../pages/Adjustment/Adjustment.helpers';
import { Label } from './FormHelpers';
import { getIntent, logOnFieldComplete, required } from './forms.helpers';

import type { PriceAdjustmentReasonOption } from '../../pages/Adjustment/Adjustment.helpers';

export const Select = ({ data = [], name, label }:
{
  data?: readonly PriceAdjustmentReasonOption[] | PriceAdjustmentReasonOption['children'] | {
    disabled?: boolean;
    text: string;
    value: string | number;
  }[];
  label: string;
  name: string;
},
) => {
  const formatData = data.map(option => typeof option === 'string' ? { text: option, value: option } : option);

  return (
    <section>
      <Field name={name} validate={required}>
        {({ input, meta }) => (
          <SelectTHC
            formProps={{
              input: {
                ...input,
                onBlur: logOnFieldComplete(meta, input.onBlur),
              },
            }}
            fullWidth
            id={name}
            intent={getIntent(meta)}
            label={Label(label)}
            showLabel
          >
            {formatData.map((option, i) => (
              <option
                disabled={option.disabled ?? option.text === PLACEHOLDER_TEXT}
                key={`${option.text}-${i.toString()}`}
                value={option.value}
              >
                {option.text}
              </option>
            ))}
          </SelectTHC>
        )}
      </Field>
    </section>
  );
};
